import { Injectable, inject } from '@angular/core';
import { SiaCacheDatabaseService } from '@sia/shared';
import CustomStore from 'devextreme/data/custom_store';
import { GridConfig } from '../interfaces/grid-config';
import { GridDataApi } from './grid-data-api';
@Injectable({
  providedIn: 'root',
})
export class GridDataService {
  #cacheDatabaseService = inject(SiaCacheDatabaseService);
  #gridDataApi = inject(GridDataApi);

  states: { id: string; value: string }[] = [];

  getFilterDataSource(
    controllerId: string,
    componentId: string | null,
    dataField: string | undefined,
    filters: string | undefined,
  ): Promise<{ text: string; value: any }[]> {
    return this.#gridDataApi.getFilterDataSource(
      controllerId,
      componentId,
      dataField,
      filters,
    );
  }

  clearAllResponseContaining(gridId: string | null) {
    if (!gridId) {
      return Promise.resolve(false);
    }
    return this.#cacheDatabaseService.clearAllResponsesContaining(gridId);
  }

  store(
    deviceType: string,
    gridId: string,
    useSp: boolean,
    keysIds: string[],
    gridConfig: GridConfig,
    controller: any = null,
    gridComponent: any,
  ): Promise<CustomStore> {
    let controllers = controller;
    let useCache = false;
    let cacheKey = '';

    if (gridConfig && !controllers) {
      controllers = {
        default: gridConfig.controller,
        insert: gridConfig.addingController,
        edit: gridConfig.updatingController,
        delete: gridConfig.deletingController,
      };
      useCache = gridConfig.useCache ?? false;
      cacheKey = gridConfig.cacheKey ?? '';
    }
    return Promise.resolve(
      this.#gridDataApi.getStore(
        controllers,
        gridId,
        useSp,
        useCache,
        cacheKey,
        keysIds,
        gridComponent,
      ),
    );
  }

  idsClick(
    idsSP: string | undefined,
    ids: string,
    gridId: string,
  ): Promise<boolean> {
    return this.#gridDataApi.idsClick(idsSP, ids, gridId);
  }

  getGridState(id: string): any {
    let index = this.states.findIndex((x) => x.id == id);
    if (index == -1) {
      return null;
    } else {
      var state = this.states[index];
      return JSON.parse(state.value);
    }
  }
  saveGridState(id: string, value: any) {
    let index = this.states.findIndex((x) => x.id == id);
    if (index == -1) {
      this.states.push({ id: id, value: JSON.stringify(value) });
    } else {
      this.states[index] = { id: id, value: JSON.stringify(value) };
    }
  }
}
